module.exports = __webpack_public_path__ + "img/ava_ad1x1.16bc8f91.png";